import React , { Component, PropTypes } from 'react'

import LivresList from './livreslist';


class AuteurLivres extends Component{
    constructor(props){
        super(props);
        this.state = {'sort' : {'field' : 'cdate', 'dir': 'desc'}};
        this.handleSort = this.handleSort.bind(this);

    }

    componentDidMount(){
        if (this.props.livres.length === 0){
            this.props.fetchAuteurLivres(this.props.aid);
        //} else {
        //    console.log('livres already fetched..');
        }
    }

    handleSort(field){

        if (this.state.sort.field === field){
            // change the direction
            this.setState({'sort' : {field: field, dir : this.state.sort.dir === 'asc' ? 'desc' : 'asc'}})
        } else {
            this.setState({'sort' : {field : field, dir : 'asc'}});
        }
    }

    render(){
        if (this.props.loading){
            return (<div className="center-block loader"></div>);
        }
        if (this.props.livres.length == 0){
            return (<div>Pas de livres</div>);
        }
        let livres_withcrit = this.props.livres.filter((el)=>{
            return (el.nbr > 0);
        });
        let livres_withoutcrit = this.props.livres.filter((el)=>{
            return (el.nbr == 0);
        });
        // sort
        livres_withcrit.sort((el1,el2)=>{
            if (el1[this.state.sort.field] == el2[this.state.sort.field]){
                return 0
            };
            if (this.state.field == 'nbr' || this.state.field == 'star'){
                if (this.state.sort.dir == 'asc'){
                    return el1[this.state.sort.field] - el2[this.state.sort.field] ;
                } else {
                    return el2[this.state.sort.field] - el1[this.state.sort.field] ;                    
                }
            }
            if (this.state.sort.dir == 'asc'){
                if (el1[this.state.sort.field] > el2[this.state.sort.field]){
                    return 1
                };
                if (el1[this.state.sort.field] < el2[this.state.sort.field]){
                    return -1
                };
            }
            if (this.state.sort.dir == 'desc'){
                if (el1[this.state.sort.field] > el2[this.state.sort.field]){
                    return -1
                };
                if (el1[this.state.sort.field] < el2[this.state.sort.field]){
                    return 1
                };
            }
        });
        let livreString = 'livres';
        let critiqueString = 'critiqués';
        if (livres_withcrit.length === 1){
            livreString = 'livre';
            critiqueString = 'critiqué';
        }
        return (
            <div>
            {livres_withcrit.length > 0 && (
                <div className="row">
                    <div className="col-md-12 col-lg-10">
                        <h3>{livres_withcrit.length} {livreString} de {this.props.auteur1} {critiqueString} sur le site</h3>
                        <LivresList livres={livres_withcrit} handleSort={this.handleSort} sort={this.state.sort} />
                    </div>
                </div>
            )}
            {livres_withoutcrit.length > 0 && (
                    <div className="row">
                        <div className="col-md-12 col-lg-10">
                            <h3>Livres non-critiqués sur le site ou dont {this.props.auteur1} n'est pas l'auteur principal</h3>
                            <LivresList livres={livres_withoutcrit} />
                        </div>
                    </div>
                )
            }
            </div>

        )
    }
}

AuteurLivres.propTypes = {
    'loading': PropTypes.bool.isRequired,
    'livres': PropTypes.arrayOf(PropTypes.shape({
        'amz_img_l': PropTypes.string,
        'amz_img_m': PropTypes.string,
        'amz_img_s': PropTypes.string,
        'cover': PropTypes.shape({
            'L' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
            'S' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
            'M' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
        }),
        'cdate' : PropTypes.string,
        'isbn' : PropTypes.string,
        'asin' : PropTypes.string,
        'livreid' : PropTypes.number,
        'ownedbook': PropTypes.number,
        'titre' : PropTypes.string,
        'titrelivre': PropTypes.string,
        'titreorig': PropTypes.string,
        'pseudo': PropTypes.string,
        'uid': PropTypes.string,
        'nbr': PropTypes.number,
        'star': PropTypes.number,
        'editeur' : PropTypes.number,
        'editeur_nom' : PropTypes.string,
        'collection' : PropTypes.string
    })),
    'lastRefreshed': PropTypes.instanceOf(Date)
}


export default AuteurLivres



// WEBPACK FOOTER //
// ./auteur/livres/AuteurLivres.jsx